// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Random = require("rescript/lib/js/random.js");
var Router$PdgLookup = require("./Router.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var PageNotFound$PdgLookup = require("./pages/PageNotFound.bs.js");
var PageParticle$PdgLookup = require("./pages/PageParticle.bs.js");

var backgroundColours = [
  "#FFCE9D",
  "#FFE8BC",
  "#AEE2D3",
  "#80CCD0",
  "#72A7C7",
  "#E9D2E0"
];

function getRandomColour() {
  return backgroundColours[Random.$$int(backgroundColours.length)];
}

function App(props) {
  var route = Router$PdgLookup.useRouter();
  Random.self_init();
  var element = document.querySelector("body");
  if (!(element == null)) {
    element.style["background-color"] = getRandomColour();
  }
  if (route !== undefined) {
    return JsxRuntime.jsx(PageParticle$PdgLookup.make, {});
  } else {
    return JsxRuntime.jsx(PageNotFound$PdgLookup.make, {});
  }
}

var make = App;

exports.backgroundColours = backgroundColours;
exports.getRandomColour = getRandomColour;
exports.make = make;
/* Router-PdgLookup Not a pure module */
